<div class="login" fxLayout="column" fxLayoutAlign="center">
	<div fxLayout="row" fxLayoutAlign="center center" style="height:100%; overflow: auto;">
		<mat-card class="padding-25 mat-elevation-z5 top-10" fxFlex="500px" fxFlex.sm="80%" fxFlex.lt-sm="100%">
			<form [formGroup]="loginForm" fxLayout="column" (ngSubmit)="loginForm.valid && onSubmit(loginForm.value)"
				autocomplete="off" autocorrect="off" fxLayoutGap="25px" novalidate>

				<!--Image Logo-->

				<img class="logo" src="assets/images/boc-logo.png" alt="Bayanibox logo">
				<div class="mat-primary-color title">{{ 'TITLE_WELCOME' | translate }}</div>

				<div class="app-name-container">
					<img class="app-logo" src="assets/images/bayanibox-logo.png" alt="Bayanibox logo">
					<div class="subtitle">{{ 'PROJECT_NAME' | translate }}</div>
				</div>

				<mat-label escCustomId="form_error" class="mat-warn-color mat-subheading-1" *ngIf="errorMessage">
					{{errorMessage}}
				</mat-label>

				<mat-form-field>
					<input matInput escCustomId="email" [placeholder]="'LABEL_EMAIL_ADDRESS' | translate"
						formControlName="username" autocomplete="off" required escCustomId="email">
					<mat-error escCustomId="email_required_error"
						*ngIf="loginForm.controls['username'].hasError('required')">
						{{ 'FORM_ERROR_REQUIRED' | translate }}
					</mat-error>
					<mat-error escCustomId="email_invalid_error"
						*ngIf="loginForm.controls['username'].hasError('whitespace')">
						{{ 'FORM_ERROR_INVALID' | translate: { field: 'Email'} }}
					</mat-error>
					<mat-error escCustomId="email_invalid_error"
						*ngIf="loginForm.controls['username'].hasError('pattern')">
						{{ 'FORM_ERROR_INVALID' | translate: { field: 'Email'} }}
					</mat-error>
				</mat-form-field>

				<mat-form-field>
					<input escCustomId="password" matInput [placeholder]="'PASSWORD' | translate"
						formControlName="password" [type]="isPasswordShown ? 'text' : 'password'" required>
					<mat-icon escCustomId="show_password" *ngIf="loginForm.controls['password'].value"
						[svgIcon]="isPasswordShown ? 'eye-off' : 'eye'" (click)="isPasswordShown = !isPasswordShown"
						matSuffix>
					</mat-icon>

					<mat-error escCustomId="password_required_error"
						*ngIf="loginForm.controls['password'].hasError('required')">
						{{ 'FORM_ERROR_REQUIRED' | translate }}
					</mat-error>
				</mat-form-field>


				<button escCustomId="login" color="primary" [disabled]="isSubmitting" mat-raised-button type="submit">{{
					(isSubmitting ? 'LOGGING_IN' :
					'LOGIN') | translate }}</button>

				<div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center center">
					<!-- <mat-checkbox escCustomId="rememeber_me" formControlName="rememberMe">
						<mat-label>{{ 'REMEMBER_ME' | translate }}</mat-label>
					</mat-checkbox> -->

					<button escCustomId="forgot_password" mat-button routerLink="../forgot-password"
						[queryParams]="loginForm.controls['username'].valid ? { username: loginForm.controls['username'].value } : {}"
						color="primary" class="mat-primary-color">{{ 'FORGOT_PASSWORD' | translate }}</button>
				</div>

				<div *ngIf="authService.isSignUpAllowed()" fxLayout="column" fxLayout.lt-sm="column"
					fxLayoutAlign="space-around center">

					<mat-label escCustomId="dont_have_an_account" class="mat-body-1 center">{{
						'MESSAGE_DONT_HAVE_ACCOUNT' | translate}}</mat-label>

					<button escCustomId="signup" mat-button color="primary" class="mat-body mat-primary-color"
						type="button" (click)="onSignUp()">
						{{ 'SIGN_UP' | translate }}
					</button>
				</div>

				<p>{{ 'POWERED_BY' | translate }}</p>

				<!--Image Logo-->
				<img class="logo" src="assets/images/escience-banner.png" alt="E-Science Logo">

			</form>
		</mat-card>

	</div>

	<esc-footer></esc-footer>

</div>